import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import { KoAdjustment } from '../tokens/lender-risk-rules.token';
import { KoAdjustmentsAdminApi } from '../tokens/ko-adjustments.token';

/**
 * REST-only {@link KoAdjustmentsAdminApi} (EM-1675 / S7.4) —
 * `/api/master-admin/ko-adjustment-requests` through the gateway. Errors are RFC 7807 and reach the
 * caller untouched for `extractBackendErrorMessage` (Rule 09). Rules 07/10 — no mock sibling.
 */
@Injectable()
export class KoAdjustmentsAdminRestService implements KoAdjustmentsAdminApi {
  private readonly http = inject(HttpClient);

  list(status: string | null): Observable<KoAdjustment[]> {
    let params = new HttpParams();
    if (status) {
      params = params.set('status', status);
    }
    return this.http.get<KoAdjustment[]>(API_PATHS.MASTER_ADMIN_KO_ADJUSTMENTS, { params });
  }

  decide(requestId: number, approve: boolean, reason: string | null): Observable<KoAdjustment> {
    return this.http.post<KoAdjustment>(`${API_PATHS.MASTER_ADMIN_KO_ADJUSTMENTS}/${requestId}/decision`, {
      approve,
      reason,
    });
  }
}
